<template>
    <common-modal v-if="isOpen" width="medium" @close="emitEvent({ name: 'close' })">
        <common-content-wrapper width="large">
            <common-content-spacer height="medium">
                <common-page-header
                    :isCenter="true"
                    :heading="$t('modals.primary_care_email_modal.heading')"
                ></common-page-header>

                <common-content-wrapper width="small">
                    <common-content-spacer height="medium">
                        <p class="direct-referral__title">
                            {{ $t('modals.primary_care_email_modal.add_email') }}
                        </p>

                        <form-wrapper @submit="submitEmail(data)">
                            <common-content-spacer height="medium">
                                <text-field
                                    :label="$t('modals.primary_care_email_modal.inputs.email.label')"
                                    :placeholder="$t('modals.primary_care_email_modal.inputs.email.placeholder')"
                                    :formData="data"
                                    :isRequired="true"
                                    valuePath="email"
                                    type="email"
                                    @change="emailChanged($event)"
                                ></text-field>

                                <common-buttons>
                                    <common-button
                                        :label="$t('modals.primary_care_email_modal.buttons.add_email')"
                                        type="primary"
                                    ></common-button>
                                </common-buttons>
                            </common-content-spacer>
                        </form-wrapper>

                        <common-divider class="direct-referral__header">
                            <b>{{ $t('modals.primary_care_email_modal.or') }}</b>
                        </common-divider>
                        <p class="direct-referral__title">
                            {{ $t('modals.primary_care_email_modal.continue_without_email') }}
                        </p>

                        <common-buttons>
                            <common-button
                                :label="$t('modals.primary_care_email_modal.buttons.request_appointment')"
                                type="secondary"
                                @click="requestAppointment"
                            ></common-button>
                        </common-buttons>
                    </common-content-spacer>
                </common-content-wrapper>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    import FormFragmentMixin from 'mixins/FormFragmentMixin'

    export default {
        mixins: [FormFragmentMixin],

        props: {
            isOpen: { type: Boolean, required: true },
        },

        data() {
            return {
                data: {
                    email: null,
                },
            }
        },

        methods: {
            emailChanged(event) {
                this.data.email = event.value
            },

            submitEmail() {
                this.emitEvent({ name: 'request-appointment', payload: { email: this.data.email } })
            },

            requestAppointment() {
                this.emitEvent({ name: 'request-appointment' })
            },
        },
    }
</script>
